const DidomiGtag = {
  install () {
    window.didomiOnReady = window.didomiOnReady || []
    window.didomiOnReady.push(function (Didomi) {
      if (Didomi.isConsentRequired()) {
        // Consent is required: your visitor is from the EU or you are an EU company
        Didomi.getObservableOnUserConsentStatusForVendor('c:googleana-4TXnJigR')
          .subscribe(function (consentStatusForVendor) {
            // The user has given consent to the vendor
            // Enable it
            if (consentStatusForVendor) {
              window['ga-disable-' + window.PROPERTIES.get('GOOGLE_ANALYTICS_ID')] = false
            } else {
              window['ga-disable-' + window.PROPERTIES.get('GOOGLE_ANALYTICS_ID')] = true
            }
          })
      } else {
        // Consent is not required, enable your vendor immediately
        window['ga-disable-' + window.PROPERTIES.get('GOOGLE_ANALYTICS_ID')] = false
      }
    })
  }
}

export default DidomiGtag